(function () {
  "use strict";

  var rootSelector = "[data-zv-product-hero]";

  function parseJson(root, selector, fallback) {
    var node = root.querySelector(selector);

    if (!node) {
      return fallback;
    }

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || "USD"
      }).format(cents / 100);
    } catch (error) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function formatSavings(cents, currency) {
    var formatted = formatMoney(cents, currency);
    return formatted.replace(/\.00(?=\D*$)/, "") + " OFF";
  }

  function updateGallery(root, variant) {
    if (!variant || !variant.featured_media) {
      return;
    }

    var thumbnail = root.querySelector(
      "[data-zonveer-product-thumbnail][data-media-id='" + variant.featured_media.id + "']"
    );

    if (thumbnail) {
      thumbnail.click();
    }
  }

  function connectOverview(root) {
    var overview = root.querySelector("[data-zv-overview]");

    if (!overview) {
      return;
    }

    var button = overview.querySelector("[data-zv-overview-toggle]");
    var label = overview.querySelector("[data-zv-overview-label]");

    if (!button || !label) {
      return;
    }

    button.addEventListener("click", function () {
      var isOpen = overview.classList.toggle("is-open");
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      label.textContent = isOpen
        ? button.dataset.closeLabel
        : button.dataset.openLabel;
    });
  }

  function connectQuantity(root) {
    var input = root.querySelector("[data-zv-quantity]");

    if (!input) {
      return;
    }

    var minus = root.querySelector("[data-zv-quantity-minus]");
    var plus = root.querySelector("[data-zv-quantity-plus]");

    if (minus) {
      minus.addEventListener("click", function () {
        input.value = Math.max(1, (Number(input.value) || 1) - 1);
      });
    }

    if (plus) {
      plus.addEventListener("click", function () {
        input.value = (Number(input.value) || 1) + 1;
      });
    }
  }

  function updateInventory(root, variant) {
    var inventory = root.querySelector("[data-zv-inventory]");

    if (!inventory || !variant) {
      return;
    }

    var label = inventory.querySelector("[data-zv-inventory-label]");
    var quantity = Number(variant.inventory_quantity);
    var threshold = Number(inventory.dataset.lowStockThreshold) || 0;
    var isLow = variant.available && quantity > 0 && quantity <= threshold;
    var text = variant.available
      ? inventory.dataset.inStockLabel
      : inventory.dataset.outOfStockLabel;

    if (isLow) {
      text = (inventory.dataset.lowStockLabel || "Only [quantity] left").replace("[quantity]", quantity);
    }

    inventory.classList.toggle("is-low", isLow);
    inventory.classList.toggle("is-out", !variant.available);

    if (label) {
      label.textContent = text;
    }
  }

  function connectCopyButtons(root) {
    root.querySelectorAll("[data-zv-copy-code]").forEach(function (button) {
      button.addEventListener("click", function () {
        var code = button.dataset.code || button.textContent.trim();

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            var original = button.textContent;
            button.textContent = button.dataset.copiedLabel || "Copied";
            window.setTimeout(function () {
              button.textContent = original;
            }, 1500);
          });
        }
      });
    });
  }

  function connectCountdowns(root) {
    root.querySelectorAll("[data-zv-countdown-hours], [data-zv-countdown-beijing-hour]").forEach(function (countdown) {
      var output = countdown.querySelector("[data-zv-countdown-output]");
      var usesBeijingReset = countdown.hasAttribute("data-zv-countdown-beijing-hour");
      var end;

      function nextBeijingReset(now) {
        var beijingOffset = 8 * 60 * 60 * 1000;
        var beijingNow = new Date(now + beijingOffset);
        var resetHour = Math.min(23, Math.max(0, Number(countdown.dataset.zvCountdownBeijingHour) || 0));
        var target = Date.UTC(
          beijingNow.getUTCFullYear(),
          beijingNow.getUTCMonth(),
          beijingNow.getUTCDate(),
          resetHour - 8,
          0,
          0,
          0
        );

        if (target <= now) {
          target += 24 * 60 * 60 * 1000;
        }

        return target;
      }

      if (usesBeijingReset) {
        end = nextBeijingReset(Date.now());
      } else {
        var hours = Math.max(1, Number(countdown.dataset.zvCountdownHours) || 24);
        var storageKey = "zv-countdown-" + root.dataset.sectionId + "-" + hours;
        end = Number(window.localStorage.getItem(storageKey));

        if (!end || end <= Date.now()) {
          end = Date.now() + hours * 60 * 60 * 1000;
          window.localStorage.setItem(storageKey, String(end));
        }
      }

      function render() {
        if (usesBeijingReset && end <= Date.now()) {
          end = nextBeijingReset(Date.now());
        }

        var remaining = Math.max(0, end - Date.now());
        var totalSeconds = Math.floor(remaining / 1000);
        var displayHours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (output) {
          output.textContent = [displayHours, minutes, seconds].map(function (value) {
            return String(value).padStart(2, "0");
          }).join(":");
        }
      }

      render();
      window.setInterval(render, 1000);
    });
  }

  function connectHalloweenCountdowns(root) {
    root.querySelectorAll("[data-zv-halloween-countdown]").forEach(function (countdown) {
      var end = Date.parse(countdown.dataset.zvHalloweenEnd || "");
      if (!Number.isFinite(end) || end <= Date.now()) {
        countdown.hidden = true;
        return;
      }

      var nodes = [
        countdown.querySelector("[data-zv-halloween-days]"),
        countdown.querySelector("[data-zv-halloween-hours]"),
        countdown.querySelector("[data-zv-halloween-minutes]"),
        countdown.querySelector("[data-zv-halloween-seconds]")
      ];
      function render() {
        var remaining = end - Date.now();
        if (remaining <= 0) {
          countdown.hidden = true;
          window.clearInterval(interval);
          return;
        }
        var total = Math.floor(remaining / 1000);
        var values = [
          Math.floor(total / 86400),
          Math.floor((total % 86400) / 3600),
          Math.floor((total % 3600) / 60),
          total % 60
        ];
        nodes.forEach(function (node, index) {
          if (node) node.textContent = String(values[index]).padStart(2, "0");
        });
      }
      var interval = window.setInterval(function () {
        if (!countdown.isConnected) {
          window.clearInterval(interval);
          return;
        }
        render();
      }, 1000);
      render();
    });
  }

  function connectVariants(root) {
    var variants = parseJson(root, "[data-zv-variants]", []);
    var config = parseJson(root, "[data-zv-product-config]", {});
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll("[data-zv-option]"));

    if (!variants.length) {
      return;
    }

    var idInput = root.querySelector("[data-zv-variant-id]");
    var currentPrice = root.querySelector("[data-zv-current-price]");
    var comparePrice = root.querySelector("[data-zv-compare-price]");
    var savings = root.querySelector("[data-zv-savings]");
    var submit = root.querySelector("[data-zv-submit]");
    var submitLabel = root.querySelector("[data-zv-submit-label]");
    var sku = root.querySelector("[data-zv-sku]");

    /* Products with only "Default Title" have no option controls. Always
       populate the hidden variant id so native/AJAX cart requests are valid. */
    if (!optionInputs.length) {
      if (idInput) {
        idInput.value = variants[0].id;
      }
      updateInventory(root, variants[0]);
      return;
    }

    function selectedOptions() {
      var fields = Array.prototype.slice.call(root.querySelectorAll("[data-option-position]"));

      return fields
        .sort(function (a, b) {
          return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
        })
        .map(function (field) {
          var selected = field.querySelector("[data-zv-option]:checked");
          return selected ? selected.value : null;
        });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function updateSelectedLabels() {
      root.querySelectorAll("[data-option-position]").forEach(function (field) {
        var selected = field.querySelector("[data-zv-option]:checked");
        var output = field.querySelector("[data-zv-selected-value]");

        if (selected && output) {
          output.textContent = selected.value;
        }
      });
    }

    function updateVariant() {
      var variant = findVariant(selectedOptions());

      updateSelectedLabels();

      if (!variant) {
        if (submit) {
          submit.disabled = true;
        }
        if (submitLabel) {
          submitLabel.textContent = config.soldOutLabel || "Unavailable";
        }
        return;
      }

      if (idInput) {
        idInput.value = variant.id;
      }
      if (currentPrice) {
        currentPrice.textContent = formatMoney(variant.price, config.currency);
      }

      var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (comparePrice) {
        comparePrice.classList.toggle("is-hidden", !hasDiscount);
        comparePrice.textContent = hasDiscount
          ? formatMoney(variant.compare_at_price, config.currency)
          : "";
      }
      if (savings) {
        savings.classList.toggle("is-hidden", !hasDiscount);
        savings.textContent = hasDiscount
          ? formatSavings(variant.compare_at_price - variant.price, config.currency)
          : "";
      }
      if (submit) {
        submit.disabled = !variant.available;
      }
      if (submitLabel) {
        submitLabel.textContent = variant.available
          ? config.addToCartLabel || "Add to cart"
          : config.soldOutLabel || "Sold out";
      }
      if (sku) {
        sku.textContent = variant.sku || "—";
      }

      updateInventory(root, variant);

      updateGallery(root, variant);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener("change", updateVariant);
    });
  }

  function announce(root, message, isError) {
    var region = root.querySelector("[data-zv-cart-status]");
    if (!region) {
      region = document.createElement("div");
      region.className = "visually-hidden";
      region.setAttribute("aria-live", "polite");
      region.setAttribute("data-zv-cart-status", "");
      root.appendChild(region);
    }
    region.textContent = message;
    region.dataset.error = isError ? "true" : "false";
  }

  function refreshAndOpenCartDrawer(root) {
    /* Victory owns its drawer through themeCore.EventBus. This is the same
       refresh-and-open path used by the live product template and keeps
       cart items, count, subtotal and third-party widgets in sync. */
    if (
      window.themeCore &&
      window.themeCore.EventBus &&
      typeof window.themeCore.EventBus.emit === "function"
    ) {
      window.themeCore.EventBus.emit("cart:drawer:refresh-and-open");
      return Promise.resolve();
    }

    var drawer = document.querySelector("#CartDrawer");
    var trigger = document.querySelector('[data-js-toggle="CartDrawer"][aria-controls="CartDrawer"], [data-js-toggle="CartDrawer"][data-target="CartDrawer"]');

    function open() {
      if (trigger) {
        trigger.click();
      } else if (drawer) {
        drawer.classList.remove("is-empty");
        drawer.classList.add("is-active", "is-open");
        drawer.setAttribute("aria-hidden", "false");
      }
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }

    if (!drawer || !drawer.dataset.sectionId) {
      open();
      return Promise.resolve();
    }

    var sectionId = drawer.dataset.sectionId;
    var refreshUrl = (root.dataset.cartUrl || "/cart") + "?sections=" + encodeURIComponent(sectionId);
    return fetch(refreshUrl, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart drawer refresh failed");
        return response.json();
      })
      .then(function (sections) {
        var html = sections[sectionId];
        if (html) {
          var holder = document.createElement("div");
          holder.innerHTML = html;
          var fresh = holder.querySelector("#CartDrawer");
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        drawer.classList.remove("is-empty");
        open();
      })
      .catch(function () {
        open();
      });
  }

  function connectProductForm(root) {
    var form = root.querySelector("form[data-zv-product-form], form.zv-product-hero__form");
    if (!form || form.dataset.zvAjaxConnected === "true") return;
    form.dataset.zvAjaxConnected = "true";

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var submit = form.querySelector("[data-zv-submit]");
      var idInput = form.querySelector("[data-zv-variant-id]");
      var variants = parseJson(root, "[data-zv-variants]", []);
      var variantId = Number(idInput && idInput.value) || Number(variants[0] && variants[0].id);
      var quantity = Math.max(1, Number(form.querySelector("[data-zv-quantity]") && form.querySelector("[data-zv-quantity]").value) || 1);

      if (!variantId) {
        announce(root, "Please select an available product option.", true);
        return;
      }

      var items = [{ id: variantId, quantity: quantity }];
      root.querySelectorAll("[data-zv-gift-variant-id]").forEach(function (gift) {
        var giftId = Number(gift.dataset.zvGiftVariantId);
        if (giftId && !items.some(function (item) { return item.id === giftId; })) {
          items.push({ id: giftId, quantity: quantity });
        }
      });

      if (submit) submit.disabled = true;
      fetch(root.dataset.cartAddUrl || "/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (error) { throw new Error(error.description || "Unable to add to cart"); });
          return response.json();
        })
        .then(function () {
          announce(root, "Added to cart.", false);
          return refreshAndOpenCartDrawer(root);
        })
        .catch(function (error) {
          announce(root, error.message || "Unable to add to cart.", true);
          window.alert(error.message || "Unable to add to cart.");
        })
        .then(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function dedupeProductDataDrawerOpeners(root) {
    var sectionId = root.dataset.sectionId || "";
    var targetPrefix = sectionId ? "ZonveerDataDrawer-" + sectionId + "-" : "ZonveerDataDrawer-";
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-zv-data-drawer-open]"))
      .filter(function (opener) {
        return (opener.dataset.zvDataDrawerOpen || "").indexOf(targetPrefix) === 0;
      });
    var groups = {};

    openers.forEach(function (opener) {
      var target = opener.dataset.zvDataDrawerOpen;
      if (!target) return;
      if (!groups[target]) groups[target] = [];
      groups[target].push(opener);
    });

    Object.keys(groups).forEach(function (target) {
      var duplicates = groups[target];
      if (duplicates.length <= 1) return;

      /* Mobile protection / sticky widgets can clone the first product-data
         control after the hero has initialized. Identify the canonical opener
         by preferring the wrapper that contains the full set of product-data
         triggers (Specification / What's in the Box / FAQs), then hide any
         extra opener that points at the same drawer. */
      var primary = duplicates.reduce(function (best, current) {
        function score(opener) {
          var wrapper = opener.closest(".zv-product-data-accordions");
          var count = wrapper ? wrapper.querySelectorAll("[data-zv-data-drawer-open]").length : 0;
          var insideRoot = root.contains(opener) ? 10 : 0;
          return count * 100 + insideRoot;
        }
        return score(current) > score(best) ? current : best;
      });

      duplicates.forEach(function (opener) {
        if (opener === primary) return;
        var wrapper = opener.closest(".zv-product-data-accordions");
        var triggerCount = wrapper ? wrapper.querySelectorAll("[data-zv-data-drawer-open]").length : 0;

        if (wrapper && triggerCount === 1) {
          wrapper.hidden = true;
          wrapper.style.display = "none";
          wrapper.setAttribute("data-zv-stale-product-data", "true");
        } else {
          opener.hidden = true;
          opener.style.display = "none";
          opener.setAttribute("data-zv-stale-product-data", "true");
        }
      });
    });
  }

  function watchForDuplicateProductData(root) {
    if (!window.MutationObserver || root.dataset.zvProductDataDedupeWatch === "true") return;
    root.dataset.zvProductDataDedupeWatch = "true";

    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      var hasAddedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (!hasAddedNodes || scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        dedupeProductDataDrawerOpeners(root);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function connectProductDataDrawers(root) {
    dedupeProductDataDrawerOpeners(root);
    watchForDuplicateProductData(root);

    var openers = root.querySelectorAll("[data-zv-data-drawer-open]");
    var drawers = Array.prototype.slice.call(root.querySelectorAll("[data-zv-data-drawer]"));

    function closeDrawer(drawer, restoreFocus) {
      if (!drawer || drawer.hidden) return;
      var opener = root.querySelector('[data-zv-data-drawer-open="' + drawer.id + '"]');
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      if (opener) opener.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("zv-product-drawer-open");
      window.setTimeout(function () {
        if (!drawer.classList.contains("is-open")) drawer.hidden = true;
      }, 280);
      if (restoreFocus && opener) opener.focus();
    }

    drawers.forEach(function (drawer) {
      drawer.querySelectorAll("[data-zv-data-drawer-close]").forEach(function (closer) {
        closer.addEventListener("click", function () { closeDrawer(drawer, true); });
      });
      drawer.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeDrawer(drawer, true);
      });
    });

    openers.forEach(function (opener) {
      opener.addEventListener("click", function () {
        var drawer = document.getElementById(opener.dataset.zvDataDrawerOpen);
        if (!drawer) return;

        drawers.forEach(function (item) {
          if (item !== drawer && item.classList.contains("is-open")) closeDrawer(item, false);
        });

        /* Move the overlay to <body> while open so it is not trapped inside the
           sticky product panel's stacking context. This keeps footer/chat UI
           from painting above the FAQ/specification drawer. */
        if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

        drawer.hidden = false;
        drawer.setAttribute("aria-hidden", "false");
        opener.setAttribute("aria-expanded", "true");
        document.documentElement.classList.add("zv-product-drawer-open");
        window.requestAnimationFrame(function () {
          drawer.classList.add("is-open");
          var closeButton = drawer.querySelector(".zv-product-data-drawer__close");
          if (closeButton) closeButton.focus();
        });
      });
    });
  }

  function connect(root) {
    if (root.dataset.zvProductHeroConnected === "true") {
      return;
    }

    root.dataset.zvProductHeroConnected = "true";
    connectOverview(root);
    connectQuantity(root);
    connectCopyButtons(root);
    connectCountdowns(root);
    connectHalloweenCountdowns(root);
    connectVariants(root);
    connectProductForm(root);
    connectProductDataDrawers(root);
  }

  function initialize(scope) {
    var roots = [];

    if (scope.matches && scope.matches(rootSelector)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(rootSelector)));
    }

    roots.forEach(connect);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialize(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    var root = event.target.closest && event.target.closest(rootSelector);
    var overview = event.target.closest && event.target.closest("[data-zv-overview]");
    var accordion = event.target.closest && event.target.closest(".zv-product-accordion");

    if (!root) {
      return;
    }

    if (overview) {
      var button = overview.querySelector("[data-zv-overview-toggle]");
      var label = overview.querySelector("[data-zv-overview-label]");
      overview.classList.add("is-open");

      if (button) {
        button.setAttribute("aria-expanded", "true");
      }
      if (label && button) {
        label.textContent = button.dataset.closeLabel;
      }
    }

    if (accordion) {
      accordion.open = true;
    }
  });
})();
